module.exports = __webpack_public_path__ + "static/FoundersGrotesk-RegularItalic-6b1ce07fa5d1280fbe2005e17a1832f8.svg";